(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('sitefooter', sitefooter);

    /* @ngInject */
    function sitefooter() {
        var directive = {
            bindToController: true,
            templateUrl: 'sitefooter.tpl',
            controller: sitefooterCtrl,
            controllerAs: '$ctrl',
            link: link,
            restrict: 'E',
            scope: {
                globals: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {

            // if ((typeof google != 'undefined') && (typeof google.maps != 'undefined')) {
            //     scope.$watch('$root.globals', function() {
            //         if (typeof scope.$root.globals !== 'undefined') {
            //             scope.initMap();
            //         }
            //     });
            // }

            scope.$ctrl.currentYear = (new Date()).getFullYear();
        }

    }

    /* @ngInject */
    function sitefooterCtrl($scope) {
        $scope.initMap = function() {
            var placeholder = angular.element('.map-placeholder');
            var center = {
                lat: parseFloat($scope.$root.globals.site_options.maps.default_location.lat),
                lng: parseFloat($scope.$root.globals.site_options.maps.default_location.lng)
            };
            var map = new google.maps.Map(placeholder[0], {
                center: center,
                zoom: 16,
                scrollwheel: false,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            });
            new google.maps.Marker({position: center, map: map});
        };

    }

})();